import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Disciplines from "@/components/Disciplines";
import Timeline from "@/components/Timeline";
import BackUs from "@/components/BackUs";
import ResearchPipeline from "@/components/ResearchPipeline";
import SubscribeSection from "@/components/SubscribeSection";
import { AssessmentPromoSection, AssessmentPreFooter } from "@/components/AssessmentPromo";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const t = setTimeout(() => {
        const el = document.querySelector(location.hash);
        if (el) {
          if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
          else el.scrollIntoView();
        }
      }, 200);
      return () => clearTimeout(t);
    }
  }, [location.hash]);

  return (
    <main>
      <Hero />
      <Marquee />
      <Manifesto />
      <Disciplines />
      <AssessmentPromoSection />
      <ResearchPipeline />
      <Timeline />
      <BackUs />
      <SubscribeSection />
      <AssessmentPreFooter />
    </main>
  );
}
